import React, { useEffect, useState } from "react";
import "./Header.scss";
import { useNavigate } from "react-router-dom";
import LFTLogo from "../../Assets/Images/LFT_logo.png";
import { Popover, message } from "antd";
import { sessionServices } from "../../Utils/SessionServices";

function Header() {
  const navigate = useNavigate();

  const [showProfile, setShowProfile] = useState(false);
  const [userName, setUserName] = useState('');

  const getUserName = () => {
    sessionServices.getSessionStorageItem('username')
      .then((res) => {
        setUserName(res.replace(/\//g, ''))
      }).catch((err) => console.log(err))
  }

  useEffect(() => {
    getUserName();
  }, [])

  const getFirstLetters = (name) => {
    // Split the name into words
    const words = name.split(' ');
    // Extract the first letter from the first word
    const firstLetters = words[0].charAt(0);
    return firstLetters;
  }

  const showProfileFunc = () => {
    setShowProfile(!showProfile);
  };
  return (
    <div className="header">
      <div className="logo">
        <img
          className="logo-img"
          src={LFTLogo}
          onClick={() => {
            navigate("/");
          }}
          alt="LFT logo"
        />
      </div>
      <div className="roleOptions">
        <div className="userName">{userName}</div>
        <Popover
          content={
            <div className="popover-custom">
              <div className="popover-single-content" onClick={() => {
                sessionServices.clearSessionStorage()
                  .then(() => navigate('/login'))
                  .catch((err) => console.log(err))
              }}>
                <h3>Logout</h3>
              </div>
            </div>
          }
          trigger="click"
          open={showProfile}
          onOpenChange={showProfileFunc}
          placement="bottomRight"
        >
          <div
            className="userAvatar"
            onClick={() => setShowProfile(!showProfile)}
          >
            <span className="avatar-text">{getFirstLetters(userName)}</span>
          </div>
        </Popover>
      </div>
    </div>
  );
}

export default Header;
